module.exports = __webpack_public_path__ + "img/incidence-other.d168ce10.svg";